import { ReactComponent as NoImageSvg } from '../../assets/images/no-image.svg';

export const NoImageIcon: SvgIcon = (props) => {
    return <NoImageSvg {...props} />;
};
